module.exports = "/assets/data/575962801493b63000cd38a267944140-B46.data.json";